/**
 * Sticky Add-to-Cart (alle schermbreedtes)
 *
 * Toont een sticky balk onderaan het scherm zodra de originele Add-to-Cart-knop
 * (.ProductForm__AddToCart) uit beeld scrolt. De sticky-knop triggert een klik op
 * de echte knop, zodat alle bestaande cart-logica (AJAX, variant-validatie,
 * Pinterest-tracking) ongewijzigd blijft werken.
 */
(function () {
  'use strict';

  function init() {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var realButton = document.querySelector('.ProductForm__AddToCart');

    if (!stickyBar || !realButton) {
      return;
    }

    var stickyButton = stickyBar.querySelector('[data-sticky-atc-button]');
    var stickyPrice = stickyBar.querySelector('[data-sticky-atc-price]');

    // Klik op de sticky-knop -> klik door naar de echte Add-to-Cart-knop
    stickyButton.addEventListener('click', function () {
      if (stickyButton.hasAttribute('disabled')) {
        return;
      }
      realButton.click();
    });

    function showBar() {
      stickyBar.classList.add('is-visible');
      stickyBar.setAttribute('aria-hidden', 'false');
    }

    function hideBar() {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
    }

    // Toon de sticky-balk zodra de ECHTE knop niet meer zichtbaar is in het viewport
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting) {
          hideBar();
        } else {
          showBar();
        }
      },
      { root: null, threshold: 0 }
    );
    observer.observe(realButton);

    // Houd de prijs in de sticky-balk gesynchroniseerd als de klant een andere variant kiest
    var priceEl = document.querySelector('[data-money-convertible]');
    if (priceEl && stickyPrice) {
      var priceObserver = new MutationObserver(function () {
        stickyPrice.textContent = priceEl.textContent;
      });
      priceObserver.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    // Spiegel de sold-out/disabled-status van de echte knop naar de sticky-knop
    var buttonObserver = new MutationObserver(function () {
      if (realButton.hasAttribute('disabled')) {
        stickyButton.setAttribute('disabled', 'disabled');
      } else {
        stickyButton.removeAttribute('disabled');
      }
    });
    buttonObserver.observe(realButton, { attributes: true, attributeFilter: ['disabled'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
